// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// 定义一个统一的键名常量，确保一致性
const LANGUAGE_KEY = 'i18nextLng';

i18n
  // 加载语言文件的后端
  .use(Backend)
  // 使用语言检测器
  .use(LanguageDetector)
  // 将i18n实例传递给react-i18next
  .use(initReactI18next)
  // 初始化i18next
  .init({
    fallbackLng: 'en',
    lng: localStorage.getItem(LANGUAGE_KEY) || 'en',
    supportedLngs: ['en', 'zh', 'es', 'fr', 'de', 'ja','hk'],
    debug: true, // 在开发环境中启用调试
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_KEY,
    },
    backend: {
      // 修改这里 - 添加/list前缀
      loadPath: '/list/locales/{{lng}}/{{ns}}.json',
    },
  }, (err) => {
    if (err) console.error('i18next initialization error:', err);
    else console.log('i18next initialized successfully');
  });

export default i18n;